export default "__VITE_ASSET__BQA6RDvW__"